import {ComponentClassName, useEventListener} from "@dp-instant/ui";
import {GameEvents} from "@game/coregame/GameEvents";
import {CoinsField} from "@game/ui/components/CoinsIndicator/CoinsField";
import {SVG} from "@game/ui/images";
import cn from "classnames";
import {useState} from "preact/hooks";
import "./CoinsIndicator.less";

export interface CoinsIndicatorProps extends ComponentClassName {
    total?: number;
}

export const CoinsIndicator = ({className, total = 600}: CoinsIndicatorProps) => {
    const [state, setState] = useState(total);
    useEventListener(GameEvents.COINS_UPDATED, (data: {coins: number}) => setState(data.coins));
    useEventListener("YANDEX_SYNC", (data: {coins: number}) => {
        setState(data.coins);
    });
    return (
        <div className={cn(className)}>
            <CoinsField className={cn("coins-indicator__total")} total={state} />
            <div className={cn("coins-indicator__icon")}>{<SVG.COINS />}</div>
        </div>
    );
};
